import { Component, OnInit, Input } from '@angular/core';
import { IFieldColumnOptions } from '../../models';
import { DataGridComponent } from '../data-grid/data-grid.component';
import { Observable } from 'rxjs';
import { IDynamicComponent } from '../../../dynamic-component/IDynamicComponent';

@Component({
  selector: 'ps-data-grid-field-column',
  templateUrl: './data-grid-field-column.component.html',
  styleUrls: ['./data-grid-field-column.component.css']
})
export class DataGridFieldColumnComponent implements OnInit {
  @Input() model: any;
  @Input() column: IFieldColumnOptions;
  @Input() grid: DataGridComponent;

  dynamicComponent: IDynamicComponent;

  constructor() { }
  
  get displayText() {

    if (this.column.format)
      return this.column.format(this.model, this.column);

    return this.model[this.column.field];
  }

  ngOnInit() {
    if (this.column.displayComponent)
      this.dynamicComponent = this.column.displayComponent(this.model, this.column);
  }
}
